import React, { useEffect } from 'react'
import { LuX } from 'react-icons/lu'

const PdfViewerDrawer = ({ open, pdfUrl, reportId, onClose }) => {
  useEffect(() => {
    if (!open) return
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [open, onClose])

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end" role="dialog" aria-modal="true" aria-label="Credit Report PDF">
      <div
        className="absolute inset-0 bg-black/40 transition-opacity"
        onClick={onClose}
      />
      <div className="relative w-[720px] max-w-[90vw] h-full bg-paper shadow-2xl flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-divider">
          <div className="font-semibold text-lg">Credit Report PDF</div>
          <div className="flex items-center gap-3">
            {pdfUrl && (
              <>
                <a
                  href={pdfUrl}
                  download={reportId ? `credit-report-${reportId}.pdf` : 'credit-report.pdf'}
                  className="text-sm text-primary-main hover:underline"
                >
                  Download
                </a>
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-primary-main hover:underline"
                >
                  Open in new tab
                </a>
              </>
            )}
            <button
              onClick={onClose}
              aria-label="Close"
              className="p-1 rounded-md hover:bg-surface transition-colors text-text-secondary"
            >
              <LuX size={20} />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-hidden">
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="Credit Report PDF"
              className="w-full h-full border-0"
            />
          ) : (
            <div className="flex items-center justify-center h-full text-text-secondary">
              Loading PDF...
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PdfViewerDrawer
